<template>
  <section class="footer-section" ref="section">
    <!-- 배경 -->
    <div class="bg-dark"></div>

    <div class="footer-content" :class="{ visible: isVisible }">
      <!-- 상단: 로고 + 전화번호 -->
      <div class="top-area">
        <h2 class="logo-text">LOGEBIEN <span>MEGACITY</span></h2>
        <a href="tel:1800-1088" class="phone-number">1800-1088</a>
      </div>

      <!-- 중앙: 정보 그리드 -->
      <div class="info-grid">
        <div class="info-item">
          <span class="info-label">대지위치</span>
          <span class="info-value">경상북도 구미시 산동읍 동곡리 산60-3번지</span>
        </div>
        <div class="info-item">
          <span class="info-label">시행</span>
          <span class="info-value">(주)대광에이엠씨</span>
        </div>
        <div class="info-item">
          <span class="info-label">시공</span>
          <span class="info-value">(주)대광건영</span>
        </div>
        <div class="info-item">
          <span class="info-label">광고대행</span>
          <span class="info-value">(주)더한걸음</span>
        </div>
      </div>

      <!-- 하단: CTA 버튼들 -->
      <div class="cta-area">
        <div class="cta-box">
          <p class="cta-sub">계약금</p>
          <p class="cta-main">1,000만원</p>
        </div>
        <div class="cta-box">
          <p class="cta-sub">중도금</p>
          <p class="cta-main">전액 무이자</p>
        </div>
        <div class="cta-box">
          <p class="cta-sub">전매제한</p>
          <p class="cta-main">없음</p>
        </div>
      </div>

      <!-- 방문예약 버튼 -->
      <div class="reserve-btn-area">
        <button class="reserve-btn" @click="$emit('open-form')">
          <span>방문예약하기</span>
        </button>
      </div>
    </div>

    <!-- 하단 카피라이트 -->
    <div class="copyright-wrapper" :class="{ visible: isVisible }">
      <p class="disclaimer">※ 본 사이트의 CG, 일러스트, 이미지 등은 소비자의 이해를 돕기 위해 제작된 것으로 실제와 다소 상이할 수 있습니다.</p>
      <p class="disclaimer">※ 상기 이미지는 (주)더한걸음 제작이며, 동의 없이 무단 도용할 경우 법적인 처벌을 받을 수 있습니다.</p>
      <div class="copyright-line"></div>
      <p class="copyright-text">Copyright © LOGEBIEN MEGACITY All Rights Reserved.</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FooterSection',
  emits: ['open-form'],
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.isVisible = true
    }, 300)
  },
  methods: {
    getSection() {
      return this.$refs.section
    }
  }
}
</script>

<style scoped>
.footer-section {
  width: 100%;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 80px 60px;
  overflow: hidden;
}

/* 배경 */
.bg-dark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0a0a0a;
  z-index: 0;
}

/* 콘텐츠 */
.footer-content {
  position: relative;
  z-index: 10;
  max-width: 1000px;
  width: 100%;
  opacity: 0;
  transform: translateY(30px);
  transition: all 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.footer-content.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 상단 영역 */
.top-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 40px;
  border-bottom: 1px solid var(--main-color1);
  margin-bottom: 40px;
}

.logo-text {
  font-size: 26px;
  font-weight: 300;
  color: #fff;
  letter-spacing: 4px;
  margin: 0;
}

.logo-text span {
  font-weight: 600;
}

.phone-number {
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 2px;
  text-decoration: none;
  transition: color 0.3s ease;
}

.phone-number:hover {
  color: var(--main-color1);
}

/* 정보 그리드 */
.info-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin-bottom: 50px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-label {
  font-size: 12px;
  color: var(--main-color1);
  letter-spacing: 1px;
}

.info-value {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

/* CTA 영역 */
.cta-area {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.cta-box {
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 30px 20px;
  text-align: center;
  transition: all 0.3s ease;
}

.cta-box.highlight {
  border-color: var(--main-color1);
  cursor: pointer;
}

.cta-box.highlight:hover {
  background: rgba(166, 124, 82, 0.15);
}

.cta-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 0 8px 0;
  letter-spacing: 1px;
}

.cta-main {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}

/* 방문예약 버튼 */
.reserve-btn-area {
  margin-top: 30px;
  text-align: center;
}

.reserve-btn {
  display: inline-block;
  padding: 18px 60px;
  background: var(--main-color1);
  border: none;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.reserve-btn:hover {
  background: #8a6a4a;
  transform: translateY(-2px);
}

/* 카피라이트 */
.copyright-wrapper {
  position: relative;
  z-index: 10;
  margin-top: 60px;
  max-width: 1000px;
  width: 100%;
  opacity: 0;
  transform: translateY(20px);
  transition: all 1s cubic-bezier(0.16, 1, 0.3, 1) 0.3s;
}

.copyright-wrapper.visible {
  opacity: 1;
  transform: translateY(0);
}

.disclaimer {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  line-height: 1.8;
  margin: 0 0 3px 0;
}

.copyright-line {
  width: 60px;
  height: 1px;
  background: var(--main-color1);
  margin: 25px auto 20px;
}

.copyright-text {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  letter-spacing: 2px;
  margin: 0;
  text-align: center;
}

/* 반응형 */
@media (max-width: 1024px) {
  .info-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .footer-section {
    padding: 50px 24px;
    min-height: auto;
  }
  .top-area {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  .logo-text {
    font-size: 22px;
  }
  .phone-number {
    font-size: 28px;
  }
  .info-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  .cta-area {
    grid-template-columns: 1fr;
  }
  .cta-box {
    padding: 25px 20px;
  }
  .copyright-wrapper {
    margin-top: 40px;
  }
  .disclaimer {
    font-size: 10px;
  }
}

@media (max-width: 480px) {
  .logo-text {
    font-size: 18px;
    letter-spacing: 2px;
  }
  .phone-number {
    font-size: 24px;
  }
  .info-grid {
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }
  .info-label {
    font-size: 11px;
  }
  .info-value {
    font-size: 13px;
  }
  .cta-main {
    font-size: 16px;
  }
}
</style>
